module.exports = __webpack_public_path__ + "static/media/5.dadbe4d6.jpg";